import { computed, defineComponent, ref, toRefs, watch } from "vue";
import markdownIt from "markdown-it";
import hljs from "highlight.js";
import mdKatex from "@traptitech/markdown-it-katex";
import mila from "markdown-it-link-attributes";
import "highlight.js/styles/atom-one-dark-reasonable.css";
import copy from "copy-to-clipboard";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";
export default defineComponent({
  name: "AiMessage",
  props: {
    str: {
      type: String,
      default: ""
    },
    isMe: {
      type: Boolean,
      default: false
    },
    writing: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const isStop = ref(false);
    const store = useStore();
    const userInfo = computed(() => {
      return store.state.userInfo;
    });
    const {
      str
    } = toRefs(props);
    const mdi = new markdownIt({
      linkify: true,
      highlight(code, language) {
        const validLang = !!(language && hljs.getLanguage(language));
        if (validLang) {
          const lang = language ?? "";
          return highlightBlock(hljs.highlight(code, {
            language: lang
          }).value, lang);
        }
        return highlightBlock(hljs.highlightAuto(code).value, "");
      }
    });
    mdi.use(mila, {
      attrs: {
        target: "_blank",
        rel: "noopener"
      }
    });
    mdi.use(mdKatex, {
      blockClass: "katexmath-block rounded-md p-[10px]",
      errorColor: " #cc0000"
    });
    function highlightBlock(str, lang) {
      return `<pre class="code-block-wrapper">

<div class="code-block-header">

         <span class="code-block-header__lang">${lang}</span>
         <span class="code-block-header__copy" onclick="_copyToClipboard(this)">
            <svg class="fuzhi" style="display:flex" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32"><path fill="#A9B7C6" d="M28 10v18H10V10h18m0-2H10a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2Z"></path><path fill="#A9B7C6" d="M4 18H2V4a2 2 0 0 1 2-2h14v2H4Z"></path></svg>
</span>

            </div>
            <code class="hljs code-block-body ${lang}">${str}</code>
          </pre>`;
    }
    const lastHtml = ref();
    const renderHtml = ref();
    watch(str, () => {
      if (isStop.value) {
        renderHtml.value = lastHtml.value;
      } else {
        const text = str.value.replace(/(^\s*)|(\s*$)/g, "");
        renderHtml.value = mdi.render(text) || "响应中...";
      }
      lastHtml.value = renderHtml.value;
    }, {
      immediate: true
    });
    return {
      renderHtml,
      userInfo,
      start() {
        isStop.value = false;
      },
      stop() {
        isStop.value = true;
      },
      copyAll() {
        copy(str.value);
        ElMessage.success("已复制到剪切板");
      }
    };
  }
});